import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class Ecosystem extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 

        const ecosystems = JSON.parse(localStorage.getItem("ecosystems"));
      
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (

         <section className="section-padded">
        <div className='eco-cards '> 
 {ecosystems.map((item, index) => (
        <div className={index == 0 ? "eco-card eco-parent" : "eco-card"}>
     <div className="eco-logo">
    <img
      data-aos="fade-up"
      data-aos-duration="1000"
      src={item.logo}
      className="aos-init aos-animate"
      alt="Emirates Specialized Group Logo"
    />
  </div>

  <div className="eco-content-wrapper">
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      data-aos="fade-up"
      data-aos-duration="1000"
      className="readmore-wrapper aos-init aos-animate"
    >
      <div className="readmore-line"></div>
      <div className="readmore">VISIT WEBSITE</div>
    </a>
 
    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      className="eco-Content aos-init aos-animate"
    >
      <p>
      {item.description}
      </p>
    </div>
  </div>
</div>
 ))}
    
</div>
       </section>

    );
}

}

export default Ecosystem;